import { showFormAlert } from '../view/showFormAlert.js';
import { getContent } from './TOS/getContent.js';
import { getContentBM } from './TOS/getContentBM.js';

const TOS_OK = '{"aceptadas":true}';
const TYPE_BM = 'bm';

export default {
  events: {
    visible: (eWizard, stepData, params) => {
      const eContent = eWizard.querySelector('#content');
      if (eContent) {
        stepData.type = params.type;
        eContent.innerHTML = params.type === TYPE_BM ? getContentBM(stepData) : getContent(stepData);
      }
    },
    step: (eWizard, stepData, resolve, reject) => {
      const checkItems = eWizard.querySelectorAll("[name='checkMandatory");
      let checkMandatory = true;

      checkItems.forEach((check) => {
        checkMandatory = checkMandatory && check.value;
      });

      if (checkMandatory) {
        if (stepData.type === TYPE_BM) {
          Object.keys(stepData).forEach((publisherCode) => {
            stepData[publisherCode] = TOS_OK;
          });
          resolve(stepData); // OK
        } else {
          resolve(TOS_OK);
        }
      } else {
        showFormAlert();
        reject(); // KO
      }
    },
  },
  template: `
  <template label="${edicom.locale.translate('enrollment.bmcondicionesuso.title')}">
    <ewc-layout>
      <div slot="header">
        <ewc-title level="3" label="${edicom.locale.translate('enrollment.bmcondicionesuso.title')}"></ewc-title>
      </div>
      <div id="content" slot="main"></div>
    </ewc-layout>
  </template>`,
};
